export default __webpack_public_path__ + "static/media/Oops.420728a2.png";